
// TODO:BRO-1276: import DModal from '@appsumo/dorado-nuxt';
import LegacyModal from '../../utilities/LegacyModal.vue';
import LegacyCheckbox from '../../ui/LegacyCheckbox.vue';
import * as discussionService from '../../../services/discussionService';

export default {
  components: {
    LegacyModal,
    LegacyCheckbox,
  },
  emits: ['click-close', 'update-questions'],
  props: {
    // either 'question' or 'response'
    type: {
      type: String,
      required: true,
    },
    deal: {
      type: Object,
      required: true,
    },
    // only needed if launched as a response
    commentData: {
      type: Object,
      required: false,
      default: null,
    },
    // temp prior to nuxt
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      guidelinesBody: [
        `Check the FAQ and pinned comments before you post,
        your question may have already been answered!`,
        'Please don’t use this forum as a platform for requesting deal features or new terms',
        'If you have an AppSumo support related issue, shoot us an email at',
        `Be respectful of you fellow Sumo-lings and partners –
        rudeness or harassment will not be tolerated`,
      ],
      submission: '',
      isProcessing: false,
      notify: false,
      notifyLabel: 'Notify me via email when someone replies to this question',
    };
  },
  computed: {
    title() {
      return (this.type === 'question') ? 'Ask a question' : 'Add a reply';
    },
    guidelinesTitle() {
      return (this.type === 'question') ? 'a question' : 'your review';
    },
    canSubmit() {
      return !!this.submission?.length && !this.isProcessing;
    },
  },
  created() {
    discussionService.configInstance(this.$cookies);
  },
  methods: {
    onClickClose() {
      this.$emit('click-close');
    },
    toggleNotify() {
      this.notify = !this.notify;
    },
    encodeProp(key, val) {
      return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    },
    postSubmission() {
      if (this.isProcessing) {
        return;
      }

      this.isProcessing = true;
      let data = [];
      data.push(
        this.encodeProp('object_pk', this.deal.discussion.object_pk_question),
        this.encodeProp('reply_to', (this.commentData) ? this.commentData.id : 0),
        this.encodeProp('content_type', 'deals.dealcomment'),
        this.encodeProp('timestamp', this.deal.discussion.timestamp),
        this.encodeProp('security_hash', this.deal.discussion.hash_question),
        this.encodeProp('comment', this.submission),
        this.encodeProp('followup', this.notify),
        this.encodeProp('honeypot', ''),
        this.encodeProp('email', this.user.email),
        this.encodeProp('name', this.user.username),
        this.encodeProp('title', ''),
        this.encodeProp('rating', 0),
      );
      data = data.join('&');
      const callback = (successBool) => {
        this.isProcessing = false;
        if (successBool) {
          this.$toastr.s('Your comment has been made');
          this.$emit('update-questions');
        } else {
          this.$toastr.e('Something went wrong, please try again');
        }
        this.onClickClose();
      };
      discussionService.postToDiscussions(data, callback);
    },
  },
};
